import { produce } from 'immer';
import { SIGN_OUT } from 'app/store/users/types.js';
import { LOAD_PROJECT } from 'app/store/projects/types.js';

export const INITIAL_STATE = {
    isLoading: false,
    isAddingToProject: false
};

export const viewReducer = produce((draft, action) => {
    switch (action.type) {
        case LOAD_PROJECT.STARTED:
            draft.isLoading = true;
            break;
        case LOAD_PROJECT.ENDED:
            draft.isLoading = false;
            break;
        case SIGN_OUT:
            return INITIAL_STATE;
        default:
    }
}, INITIAL_STATE);
